module.exports = __webpack_public_path__ + "img/home-avisverifies.81c8099f.png";